module.exports = __webpack_public_path__ + "img/item5.837e5fea.png";